import { useRecoilValue } from "recoil";

import mainStore, { storeSetVerificationDisabledManually } from "src/stores/main";
import { useTranslation } from "src/hooks/translation";
import ToggleSwitch from "src/common/components/toggleSwitch";

import "./style.scss";

const VerificationToggle = () => {
	const t = useTranslation();
	const { verificationDisabledManually } = useRecoilValue(mainStore);

	const toggleVerification = () => storeSetVerificationDisabledManually(!verificationDisabledManually);

	return (
		<div className="B-betslip-verification-toggle">
			<span className="B-eachway">{t("I'm not registered yet")}</span>
			<ToggleSwitch onChange={toggleVerification} checked={verificationDisabledManually} />
		</div>
	);
};

export default VerificationToggle;
